import React from "react";
import { List, Popover } from "e100-react-components";

import { useStyles } from "./styles";
import { useSortOptions } from "features/myFleet/hooks/useSortOptions";
import { SortItem } from "../SortItem/SortItem";

interface SortMenuProps {
  anchorEl: HTMLElement | null;
  handleClose: () => void;
}

export const SortMenu = ({ anchorEl, handleClose }: SortMenuProps) => {
  const classes = useStyles();

  const sortOptions = useSortOptions();

  return (
    <Popover
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      anchorOrigin={{
        horizontal: "center",
        vertical: "bottom",
      }}
      transformOrigin={{
        horizontal: "center",
        vertical: "top",
      }}
      classes={{
        paper: classes.paper,
      }}
    >
      <List>
        {sortOptions.map(({ label, sortType }) => (
          <SortItem label={label} sortType={sortType} key={sortType} />
        ))}
      </List>
    </Popover>
  );
};
